import { render } from "./ShareTiku.vue?vue&type=template&id=c6b7666e"
import script from "./ShareTiku.vue?vue&type=script&lang=js"
export * from "./ShareTiku.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__